import React from 'react';
import { Paperclip } from 'icons';
import { Error, Pill } from 'components';
import { StyledPlaceholder } from 'styled';
import {
  getFullName,
  getPurchaseRequestId,
  getShortHumanReadableDate,
  getShortPurchaseRequestItemId,
  toPriceNumber,
} from 'utils';
import {
  StyledBottomContentWrapper,
  StyledDate,
  StyledDateWrapper,
  StyledH3,
  StyledHighlightedMessageH4,
  StyledItemNumberPill,
  StyledPillAndAttachmentWrapper,
  StyledPillWrapper,
  StyledRequestedBy,
  StyledRequestedByWrapper,
  StyledSpinner,
  StyledStatusIcon,
  StyledTitleAndDateWrapper,
} from './sharedElements';
/*
TODO: review naming props
*/
export const PurchaseRequestListItem = ({
  localStatus,
  t,
  focus,
  loading,
  hasAttachment,
  task: { type, title, requestDate, amount, requestor, status, id },
  override,
  showId = true,
  showItemId = false,
}) => {
  const derivedStatus =
    localStatus === '' || status !== 'PENDING' ? status : localStatus;
  return (
    <>
      <StyledTitleAndDateWrapper>
        <StyledH3 data-cy="taskListItemH3">
          {!loading ? (
            title
          ) : (
            <StyledPlaceholder height="26px" width="350px" color="primary" />
          )}
        </StyledH3>
        <StyledDateWrapper marginTop={showItemId ? '2px' : undefined}>
          {showItemId ? (
            <StyledItemNumberPill
              outlined
              label={getShortPurchaseRequestItemId(id)}
            />
          ) : null}
          <StyledDate data-cy="taskListItemRequestDate">
            {!loading ? (
              getShortHumanReadableDate(requestDate)
            ) : (
              <StyledPlaceholder height="14px" width="35px" color="secondary" />
            )}
          </StyledDate>
          {(() => {
            if (override) {
              // if (override.message) return <Warning />;
              if (override.updating) return <StyledSpinner />;
            }
            return (
              <StyledStatusIcon
                status={derivedStatus}
                data-cy={`circleStatus${derivedStatus}`}
                size="SMALL"
              />
            );
          })()}
        </StyledDateWrapper>
      </StyledTitleAndDateWrapper>

      <StyledPillAndAttachmentWrapper>
        {showId ? (
          <StyledPillWrapper>
            <Pill
              label={t(`TASK_LIST.PURCHASE_REQUESTS.${type}.PILL_LABEL`)}
              value={getPurchaseRequestId(id)}
              data-cy={focus ? 'selectedTaskListItemId' : ''}
            />
          </StyledPillWrapper>
        ) : null}
        {hasAttachment ? (
          <StyledDateWrapper>
            <Paperclip data-cy="attachmentImage" />
          </StyledDateWrapper>
        ) : null}
      </StyledPillAndAttachmentWrapper>

      <StyledBottomContentWrapper>
        {override && override.message ? (
          <Error title={t('TASK_LIST.ERROR_MESSAGE')} condition />
        ) : (
          <>
            <StyledRequestedByWrapper>
              <StyledRequestedBy>
                {!loading ? (
                  t('TASK_LIST.REQUESTED_BY', {
                    requestor: getFullName(requestor),
                  })
                ) : (
                  <StyledPlaceholder
                    height="14px"
                    width="150px"
                    color="secondary"
                  />
                )}
              </StyledRequestedBy>
            </StyledRequestedByWrapper>
            <StyledHighlightedMessageH4 data-cy="taskListItemAmount">
              {!loading ? (
                toPriceNumber(amount)
              ) : (
                <StyledPlaceholder
                  height="22px"
                  width="80px"
                  color="tertiary"
                />
              )}
            </StyledHighlightedMessageH4>
          </>
        )}
      </StyledBottomContentWrapper>
    </>
  );
};
/*
TODO: review HTML semantics
*/
